export function useHighlightPositon(
  scale: number,
  position: { x: number; y: number },
  imgWidth: number,
  imgHeight: number,
  rotation: string,
  paddingTopFix: number,
) {
  const styles = {
    position: 'absolute',

    top: 0,
    left: 0,

    transformOrigin: 'center center',

    translate: `${position.x}px ${position.y + paddingTopFix}px`,

    rotate: rotation,

    zIndex: 1,
  } as React.CSSProperties

  const viewBox = `${0} ${0} ${imgWidth} ${imgHeight}`

  const height = imgHeight * scale || 1
  const width = imgWidth * scale || 1

  if (!Number.isFinite(height) && !Number.isFinite(width)) {
    console.info('Invalid height or width:', { height, width, scale, viewBox })
  } else {
  }

  return { styles, viewBox, height, width }
}
